'use server'

import pool from '@/lib/database'
import z from 'zod'

import { s3Client } from '@/lib/s3'
import { PutObjectCommand } from '@aws-sdk/client-s3'
import { randomUUID } from 'crypto'

const FlowSchema = z.object({
    nodes: z.array(z.any()),
    edges: z.array(z.any()),
    viewport: z.object({
        x: z.number(),
        y: z.number(),
        zoom: z.number(),
    }),
})

export default async function SaveRoutePlanningBoard(board_name: string, flow_data: any, imageUrl: string | null = null, board_id: string | null = null) {
    let newBoardId = board_id // Use the provided board_id for updates, or generate a new one for inserts

    try {
        const parsedData = FlowSchema.parse(flow_data)
        console.log('Parsed flow data:', parsedData)

        if (board_id) {
            const updateQuery = 'UPDATE route_planning_boards SET flow_data = $1, name = $2 WHERE id = $3'
            await pool.query(updateQuery, [flow_data, board_name, board_id])
        } else {
            newBoardId = randomUUID()

            const insertQuery = 'INSERT INTO route_planning_boards (id, name, flow_data) VALUES ($1, $2, $3)'
            await pool.query(insertQuery, [newBoardId, board_name, flow_data])
        }

        if (imageUrl) {
            const base64Data = imageUrl.replace(/^data:image\/png;base64,/, '')
            const buffer = Buffer.from(base64Data, 'base64')

            const s3Key = `route-planning-boards/${newBoardId}/preview.png`
            await s3Client.send(
                new PutObjectCommand({
                    Bucket: process.env.S3_BUCKET_NAME!,
                    Key: s3Key,
                    Body: buffer,
                    ContentType: 'image/png',
                }),
            )
        }
    } catch (error) {
        console.error('Error parsing flow data:', error)
    }

    return newBoardId
}
